var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",style:('max-width:'+_vm.width+'px')},[_c('div',{staticClass:"row h-100 align-items-center"},[_c('div',{staticClass:"col"},[(_vm.brand)?_c('brand',{staticClass:"mb-5 text-center"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }